import {
  DeleteDoctorForCaseActionTypes,
  DELETE_DOCTOR_FOR_CASE_FAIL,
  DELETE_DOCTOR_FOR_CASE_LOADING,
  DELETE_DOCTOR_FOR_CASE_SUCCESS,
  DeleteDoctorForCaseState,
  DELETE_DOCTOR_FOR_CASE_UPDATE_API_MSG,
  DELETE_DOCTOR_FOR_CASE_UPDATE_API_RES,
} from "./ActionTypes";
import { DeleteDoctorForCaseRes } from "./Model";

const initialStateGetPosts: DeleteDoctorForCaseState = {
  loading: false,
  deleteDoctorForCaseRes: {} as DeleteDoctorForCaseRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const deleteDoctorForCaseReducer = (
  state = initialStateGetPosts,
  action: DeleteDoctorForCaseActionTypes
): DeleteDoctorForCaseState => {
  switch (action.type) {
    case DELETE_DOCTOR_FOR_CASE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DELETE_DOCTOR_FOR_CASE_SUCCESS:
      return {
        ...state,
        deleteDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
      };
    case DELETE_DOCTOR_FOR_CASE_FAIL:
      return {
        ...state,
        deleteDoctorForCaseRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DELETE_DOCTOR_FOR_CASE_UPDATE_API_MSG:
      return {
        ...state,
        deleteDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DELETE_DOCTOR_FOR_CASE_UPDATE_API_RES:
      return {
        ...state,
        deleteDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
